import React from 'react';
import { ProfileImage } from 'components/ProfileImage';
import { SecondaryButton, PrimaryButton } from 'styleguide/Buttons';
import { TextMD, TextSMRegular } from 'styleguide/Texts';
import { View } from 'styleguide/View';
import { Spacing } from 'styleguide/spacing';
import { FolderDetailViewModel } from '../FolderDetailViewModel';
import { Link } from 'components/Link';
import { observer } from 'mobx-react-lite';
import { HideOnPhoneWrapper, ShowOnPhoneWrapper } from 'styleguide/Breakpoints';
import { DividerLine } from 'styleguide/DividerLine';

export const FolderOwnerContent = observer(({ vm }: { vm: FolderDetailViewModel }) => {
  return (
    <View>
      <View>
        <Link href={`/user/${vm.username}`}>
          <HideOnPhoneWrapper style={{ display: 'flex' }}>
            <ProfileImage diameter={56} source={vm.profilePic} />
            <View style={{ marginLeft: Spacing.md, justifyContent: 'center' }}>
              <TextSMRegular>Created by</TextSMRegular>
              <TextMD>{vm.username}</TextMD>
            </View>
          </HideOnPhoneWrapper>
          <ShowOnPhoneWrapper>
            <View
              style={{
                margin: `${Spacing.md}px 0px`,
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'row',
                gap: Spacing.sm,
              }}
            >
              <ProfileImage diameter={24} source={vm.profilePic} />
              <TextSMRegular>Created by {vm.username}</TextSMRegular>
            </View>
            <DividerLine />
          </ShowOnPhoneWrapper>
        </Link>
      </View>
      {vm.isAuthenticated &&
        (vm.isFolderSaved || vm.isUsersFolder ? (
          <View style={{ marginTop: Spacing.md }}>
            {!vm.isFolderEmpty && (
              <SecondaryButton
                title={vm.existingUserSaveButtonTitle}
                style={{ marginBottom: Spacing.sm }}
                onClick={vm.onSaveFolder}
                loading={vm.isSavingFolder}
              />
            )}

            <SecondaryButton title="Copy Link to Folder" onClick={vm.onCopyUrl} iconType={'link'} />
          </View>
        ) : (
          <View style={{ marginTop: Spacing.md }}>
            {!vm.isFolderEmpty && (
              <PrimaryButton
                title={vm.existingUserSaveButtonTitle}
                style={{ marginBottom: Spacing.sm }}
                onClick={vm.onSaveFolder}
                loading={vm.isSavingFolder}
              />
            )}
            <SecondaryButton title="Copy Link to Folder" onClick={vm.onCopyUrl} iconType={'link'} />
          </View>
        ))}
    </View>
  );
});
